import React from 'react'
import Yoga from '../Images/yoga.webp';
import BodyBuilding from '../Images/bodybuilder.png';
import Zumba from '../Images/Zumba.png';
import Cardio from '../Images/Cardio.png';
import Boxing from '../Images/boxing.webp';



export const Services = () => {
  return (
    <div className='services' id='services'>
        <h1>Popular Fitness Courses</h1>
        <div className="container">
            <div className="box">
            <img src={Yoga} alt=''/>
            <h4>Yoga and Meditation</h4>
            <p>Lorem, ipsum dolor sit amet  Laboriosam ratione pariatur dignissimos sapiente velit, vel dolorum dicta  </p>
            </div>
            <div className="box">
            <img src={BodyBuilding} alt=''/>
            <h4>BodyBuilding</h4>
            <p>Lorem, ipsum dolor sit amet  Laboriosam ratione pariatur dignissimos sapiente velit, vel dolorum dicta  </p>
            </div>
            <div className="box">
            <img src={Zumba} alt=''/>
            <h4>Zumba</h4>
            <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Laboriosam ratione pariatur dignissimos sapiente </p>
            </div>
            <div className="box">
            <img src={Boxing} alt=''/>
            <h4>Yoga and Meditation</h4>
            <p>Lorem, ipsum dolor sit amet  Laboriosam ratione pariatur dignissimos sapiente velit, vel dolorum dicta  </p>
            </div>
            <div className="box">
            <img src={Cardio} alt=''/>
            <h4>Cardio</h4>
            <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Laboriosam ratione pariatur dignissimos sapiente   </p>
            </div>
            <div className='stylish'><h1>Push Yourself</h1></div>
        </div>
        <div className="container">
            
        </div>
    </div>
  )
}
